import {Component, OnDestroy, OnInit} from "@angular/core";
import {ActivatedRoute, Params} from "@angular/router";
import {WorkflowService} from "./workflow.service";

@Component({
  selector: "workflow",
  templateUrl: "./workflow.template.pug",
})

export class WorkflowComponent implements OnInit, OnDestroy {
  error: Error;

  ngOnInit(): void {
    this.route.params.forEach((params: Params) => {
      this.workflowService.updateWorkflowConfig(params["workflowId"]);
    });

    this.workflowService.workflowError.subscribe((error) => { this.error = error; });
  }

  ngOnDestroy(): void {
    this.workflowService.unsubscribe();
  }

  constructor(
    public route: ActivatedRoute,
    public workflowService: WorkflowService,
  ) {
    this.workflowService.init();
  }
}
